import Vue from 'vue';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_JIRA_PROJECTS = 'LOAD_JIRA_PROJECTS';
export const SET_JIRA_PROJECTS = 'SET_JIRA_PROJECTS';

export const SAVE_JIRA_PROJECT = 'SAVE_JIRA_PROJECT';
export const SET_JIRA_PROJECT = 'SET_JIRA_PROJECT';

export const UPDATE_PROJECT_META = 'UPDATE_PROJECT_META';
export const SEARCH_JIRA_NON_ARCHIVED_PROJECTS = 'SEARCH_JIRA_NON_ARCHIVED_PROJECTS';
export const LOAD_PROJECT_LEADS = 'LOAD_PROJECT_LEADS';
export const SET_PROJECT_LEADS = 'SET_PROJECT_LEADS';
export const SAVE_CHANGE_REQUEST = 'SAVE_CHANGE_REQUEST';
export const SET_SAVED_CHANGE_REQUEST = 'SET_SAVED_CHANGE_REQUEST';
export const DELETE_CHANGE_REQUEST = 'DELETE_CHANGE_REQUEST';
export const SET_DELETED_CHANGE_REQUEST = 'SET_DELETED_CHANGE_REQUEST';
export const SET_SAVED_CHANGE_REQUEST_ERROR = 'SET_SAVED_CHANGE_REQUEST_ERROR';
export const SET_DELETED_CHANGE_REQUEST_ERROR = 'SET_DELETED_CHANGE_REQUEST_ERROR';
export const SET_PROJECT_SELECTED_LEAD = 'SET_PROJECT_SELECTED_LEAD';

const state = {
  projects: {},
  nonArhivedProjects: {},
  projectCategories: {},
  sortedProjects: [],
  projectLeads: [],
  projectSelectedLead: {},
  changeRequestNotification: {
    data: {},
    message: '',
    status: 'loading'
  },
};

const getters = {
  projects: (state) => {
    return state.projects;
  },
  projectCategories: (state) => {
    return state.projectCategories;
  },
  sortedProjects: (state) => {
    return state.sortedProjects;
  },
  nonArhivedProjects: (state) => {
    return state.nonArhivedProjects;
  },
  projectLeads: (state) => {
    return state.projectLeads;
  },
  projectSelectedLead: (state) => {
    return state.projectSelectedLead;
  },
  changeRequestNotification: (state) => {
    return state.changeRequestNotification;
  }
};

const actions = {
  [LOAD_JIRA_PROJECTS]: function ({ commit }) {
    Backend.get('/api/jira-projects').then((response) => {
      const projects = {};
      const nonArhivedProjects = {};
      response.data.projects.forEach((project) => {
        projects[project.id] = project;
        if (projects[project.id].contingency) projects[project.id].contingency /= 100;
        if (projects[project.id].baseline_costs) projects[project.id].baseline_costs /= 100;
        if (projects[project.id].additional_actuals) projects[project.id].additional_actuals /= 100;
        if (projects[project.id].contract_budget) projects[project.id].contract_budget /= 100;
        if (project.permission_scheme != 'archived projects') nonArhivedProjects[project.id] = project;
        if (projects[project.id].change_requests.length) {
          for (const i in projects[project.id].change_requests) {
            projects[project.id].change_requests[i].baseline_costs /= 100;
            projects[project.id].change_requests[i].additional_actuals /= 100;
            projects[project.id].change_requests[i].contract_budget /= 100;
          }
        }
      });
      const projectCategories = {};
      response.data.projectCategories.forEach((category) => {
        projectCategories[category.id] = category;
      });
      // console.log("projects", projects);
      commit('SET_JIRA_PROJECTS', { projects: projects, projectCategories: projectCategories, nonArhivedProjects: nonArhivedProjects });
    });
  },
  [SEARCH_JIRA_NON_ARCHIVED_PROJECTS]: function ({ commit }, { text, lead }) {
    return Backend.get('/api/search_jira_non_archived_projects', { params: { text: text, lead: lead } });
  },
  [SAVE_JIRA_PROJECT]: function ({ commit }, project) {
    console.log(project);
    if (project.contingency) project.contingency *= 100;
    if (project.baseline_costs) project.baseline_costs *= 100;
    if (project.additional_actuals) project.additional_actuals *= 100;
    if (project.contract_budget) project.contract_budget *= 100;
    Backend.post('/api/jira-project', { project: project }).then((response) => {
      if (response.data.contingency) response.data.contingency /= 100;
      if (response.data.baseline_costs) response.data.baseline_costs /= 100;
      if (response.data.additional_actuals) response.data.additional_actuals /= 100;
      if (response.data.contract_budget) response.data.contract_budget /= 100;
      commit('SET_JIRA_PROJECT', { project: response.data });
    });
  },
  [UPDATE_PROJECT_META]: function ({ commit }, projectId) {
    Backend.patch('/api/update-project-meta', { project_id: projectId }).then((response) => {
      if (response.data[0].contingency) response.data[0].contingency /= 100;
      if (response.data[0].baseline_costs) response.data[0].baseline_costs /= 100;
      if (response.data[0].additional_actuals) response.data[0].additional_actuals /= 100;
      if (response.data[0].contract_budget) response.data[0].contract_budget /= 100;
      commit('SET_JIRA_PROJECT', { project: response.data[0] });
    });
  },
  [LOAD_PROJECT_LEADS]: function ({ commit }) {
    Backend.get('/api/jira-projects-leads').then((response) => {
      commit('SET_PROJECT_LEADS', { leads: response.data });
    });
  },
  [SAVE_CHANGE_REQUEST]: function ({ commit }, request) {
    // if(request.contingency) request.contingency *= 100;
    // if(request.baseline_costs) request.baseline_costs *= 100;
    // if(request.contract_budget) request.contract_budget *= 100;
    Backend.post('/api/save-change-request', request).then((response) => {
      commit('SET_SAVED_CHANGE_REQUEST', response.data.data);
    }, (err) => {
      console.log(err.response.data);
      commit('SET_SAVED_CHANGE_REQUEST_ERROR', err.response.data);
    });
  },
  [DELETE_CHANGE_REQUEST]: function ({ commit }, request) {
    Backend.post('/api/delete-change-request', { id: request.id }).then((response) => {
      commit('SET_DELETED_CHANGE_REQUEST', { request: request, message: response.data.data.message });
    }, (err) => {
      console.log(err.response.data.data);
      commit('SET_SAVED_CHANGE_REQUEST_ERROR', err.response.data.data);
    });
  }
};

const mutations = {
  [SET_JIRA_PROJECTS]: function (state, { projects, projectCategories, nonArhivedProjects }) {
    state.sortedProjects = Object.values(JSON.parse(JSON.stringify(nonArhivedProjects))).sort((a, b) => { return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0); });
    state.projects = projects;
    state.projectCategories = projectCategories;
    state.nonArhivedProjects = nonArhivedProjects;
  },
  [SET_JIRA_PROJECT]: function (state, { project }) {
    for (const i in project.change_requests) {
      project.change_requests[i].contract_budget /= 100;
      project.change_requests[i].contingency /= 100;
      project.change_requests[i].baseline_costs /= 100;
      project.change_requests[i].additional_actuals /= 100;
    }
    Vue.set(state.projects, project.id, project);
  },
  [SET_PROJECT_LEADS]: function (state, { leads }) {
    leads.unshift({
      project_lead_id: '',
      displayName: 'Project leads'
    });
    Vue.set(state, 'projectLeads', leads);
  },
  [SET_SAVED_CHANGE_REQUEST]: function (state, response) {
    response.data.baseline_costs /= 100;
    response.data.additional_actuals /= 100;
    response.data.contingency /= 100;
    response.data.contract_budget /= 100;
    for (const i in response.data.change_requests) {
      response.data.change_requests[i].contract_budget /= 100;
      response.data.change_requests[i].contingency /= 100;
      response.data.change_requests[i].baseline_costs /= 100;
      response.data.change_requests[i].additional_actuals /= 100;
    }
    Vue.set(state.projects, response.data.id, response.data);
    state.changeRequestNotification = {
      data: response.data,
      message: response.message,
      status: 'success'
    };
  },
  [SET_DELETED_CHANGE_REQUEST]: function (state, { request, message }) {
    for (let i = 0; i < state.projects[request.project_id].change_requests.length; i++) {
      if (state.projects[request.project_id].change_requests[i].id == request.id) {
        state.projects[request.project_id].change_requests.splice(i, 1);
      }
    }
    state.changeRequestNotification = {
      data: request,
      message: message,
      status: 'success'
    };
  },
  [SET_SAVED_CHANGE_REQUEST_ERROR]: function (state, response) {
    state.changeRequestNotification = {
      data: '',
      message: response.messages,
      status: 'error'
    };
  },
  [SET_DELETED_CHANGE_REQUEST_ERROR]: function (state, response) {
    state.changeRequestNotification = {
      data: '',
      message: response.messages,
      status: 'error'
    };
  },
  [SET_PROJECT_SELECTED_LEAD]: function (state, lead) {
    state.projectSelectedLead = lead;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
